import React from 'react'

export const FacebookIcon = () => {
  return (
<svg xmlns="http://www.w3.org/2000/svg" width="9" height="20" viewBox="0 0 9 20" fill="none">
  <path d="M8.36213 9.95276H5.77717C5.77717 14.0602 5.77717 19.116 5.77717 19.116H1.94678C1.94678 19.116 1.94678 14.1092 1.94678 9.95276H0.125977V6.71419H1.94678V4.61943C1.94678 3.11917 2.66358 0.774902 5.81237 0.774902L8.65077 0.785723V3.92945C8.65077 3.92945 6.92597 3.92945 6.59061 3.92945C6.25525 3.92945 5.77845 4.09622 5.77845 4.81166V6.71483H8.69685L8.36213 9.95276Z" fill="#063c3c"/>
</svg>
  )
}
